import BVASelect from "../../../components/BVASelect/BVASelect";
import { useState } from "react";
import { connect } from "react-redux";
import MonthlyBalanceSheetDashboard from "./MonthlyBalanceSheetDashboard/MonthlyBalanceSheetDashboard";
import MonthlyProfitAndLossDashboard from "./MonthlyProfitAndLossDashboard/MonthlyProfitAndLossDashboard";
import CashFlowDashboard from "./CashFlowDashboard/CashFlowDashboard";
import WorkingCapital from "./WorkingCapital/WorkingCapital";
import { ASCENDANT_ORDER, DESCENDANT_ORDER, MONTHLY, YEARLY } from "../../../config";
import { updateFinancialsReportDateOrder } from "../../../store/modules/financials/actions";

const BALANCE_SHEET_SECTION = "BALANCE_SHEET_SECTION";
const PROFIT_AND_LOSS_SECTION = "PROFIT_AND_LOSS_SECTION";
const CASH_FLOW_SECTION = "CASH_FLOW_SECTION";
const WORKING_CAPITAL_SECTION = "WORKING_CAPITAL_SECTION";

const acquisitionsExpensesSections = [
  { label: "Balance Sheet", value: BALANCE_SHEET_SECTION },
  { label: "Profit and Loss", value: PROFIT_AND_LOSS_SECTION },
  { label: "Cash Flow", value: CASH_FLOW_SECTION },
  { label: "Working Capital", value: WORKING_CAPITAL_SECTION },
];

const dateOrders = [
  { label: "Dates ascendant", value: ASCENDANT_ORDER },
  { label: "Dates descendant", value: DESCENDANT_ORDER },
];

const visualizationOptions = [
  { label: "Monthly", value: MONTHLY },
  { label: "Yearly", value: YEARLY }
]

function FinancialRatios({ dispatchUpdateFinancialsReportDateOrder }) {
  // States
  const [selectedSection, setSelectedSection] = useState(BALANCE_SHEET_SECTION);
  const [selectedDateOrder, setSelectedDateOrder] = useState(DESCENDANT_ORDER);
  const [selectedVisualization, setSelectedVisualization] = useState(MONTHLY);

  // Methods
  const getSection = () => {
    switch (selectedSection) {
      case BALANCE_SHEET_SECTION:
        return <MonthlyBalanceSheetDashboard dateOrder={selectedDateOrder} />;

      case PROFIT_AND_LOSS_SECTION:
        return <MonthlyProfitAndLossDashboard dateOrder={selectedDateOrder} />;

      case CASH_FLOW_SECTION:
        return <CashFlowDashboard prefix={selectedVisualization} dateOrder={selectedDateOrder} />;

      case WORKING_CAPITAL_SECTION:
        return <WorkingCapital prefix={selectedVisualization} dateOrder={selectedDateOrder} />;

      default:
        break;
    }
  };

  const handleDateOrderOnChange = (dateOrder) => {
    dispatchUpdateFinancialsReportDateOrder(dateOrder);
    setSelectedDateOrder(dateOrder);
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <BVASelect
            items={acquisitionsExpensesSections}
            value={selectedSection}
            width="24em"
            placeholder="Select a section"
            onChange={(value) => setSelectedSection(value)}
          />
          {selectedSection === CASH_FLOW_SECTION || selectedSection === WORKING_CAPITAL_SECTION ? (
            <div className="ml-4">
              <BVASelect
                items={visualizationOptions}
                value={selectedVisualization}
                width="10em"
                placeholder="Select a section"
                onChange={(value) => setSelectedVisualization(value)}
              />
            </div>
          ) : (
            <div />
          )}
        </div>
        <BVASelect
          items={dateOrders}
          value={selectedDateOrder}
          width="10em"
          placeholder="Select an order"
          onChange={handleDateOrderOnChange}
        />
      </div>
      <div className="mt-20">{getSection()}</div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateFinancialsReportDateOrder(dateOrder) {
    dispatch(updateFinancialsReportDateOrder(dateOrder));
  },
});
export default connect(null, mapDispatchToProps)(FinancialRatios);
